export default __webpack_public_path__ + "static/media/trash-green.0853e1b3.svg";